import { useCallback, useRef } from 'react';
import type { Column, FilterOpenedEvent, GridApi } from 'ag-grid-community';

import { useGridEventListener } from '@/components/AgGrid/hooks/useGridEventListener';

// `showFilter` only opens. A second call while the popup is open adds another popup, and under filter handlers the
// first is left on screen holding only the button row. AG Grid's own header toggles through an internal call, so the
// button keeps the element this column's filter opened in and closes the popup while that is on screen. The column
// menu holds no filter, so `filterOpened` for this column means its header popup.
export const useFilterPopupToggle = (
  api: GridApi,
  column: Column,
  showFilter: (button: HTMLElement | null) => void,
) => {
  const refFilterGui = useRef<HTMLElement | null>(null);

  const onFilterOpened = useCallback(
    ({ column: openedColumn, eGui }: FilterOpenedEvent) => {
      if (openedColumn === column) refFilterGui.current = eGui;
    },
    [column],
  );
  useGridEventListener(api, 'filterOpened', onFilterOpened);

  return useCallback(
    (button: HTMLElement | null) => {
      if (refFilterGui.current?.isConnected) {
        api.hideColumnFilter();
        return;
      }
      showFilter(button);
    },
    [api, showFilter],
  );
};
